//UMD模块方案
(function(window,factory){
    if(typeof exports === 'object'){
        module.exports = factory(require('jquery'));
    }else if(typeof define === 'function' && define.amd){
        define(['jquery'],factory);
    }else{
        factor();
    }
})(window,function($){

    $.fn.extend({
        moduleCarouselTop:function( params ){
            var defaults = {
                index :0,
                speed :500,
                interTime:6000,
                delayTime:4000,
                heihgt:30
            };
            var options = $.extend( defaults, params );
            return this.each(function(){
                var _moduleCarouselTop = function(){};
                _moduleCarouselTop.prototype = {
                    params:function( _options ){
                        this.P = _options; // prototype
                        this.E = {};
                        this.E.UL = $( _options.element );
                        this.C = {}; // Control
                        this.C.INDEX = this.P.index;
                        this.C.SETTIME = null;
                        this.D = {}; // Data
                        this.D.LENGTH = this.P.Length;
                        this.D.SPEED = this.P.speed;
                        this.D.interTime = this.P.interTime;
                        this.D.delayTime = this.P.delayTime;
                        this.D.height = this.P.height;
                        return this;
                    },
                    supplement:function(){
                        this.D.cur = 0;
                        return this;
                    },
                    animation:function(){
                        var that = this;
                        var ele = this.E.UL;
                        var child = ele.children();
                        var top = -(that.D.cur * this.D.height);
                        ele.animate({top:top+'px',opacity:'1'},that.D.SPEED, function () {
                            that.D.cur += 1;
                            if(that.D.LENGTH < that.D.cur){
                                var mainChild = child.eq(0);
                                var ulHei = mainChild.html();
                                if( that.D.cur % that.D.LENGTH == 0 ){
                                    $(ele).append('<ul>'+ulHei+'</ul>');
                                }
                            }
                        })
                        return this;
                    },
                    bind:function(){
                        var that = this;
                        var ele  = this.E.UL;
                        $(ele).mouseenter(function () {
                            that.stopAnimate();
                        })
                        $(ele).mouseleave(function () {
                            that.play();
                        })
                        return this;
                    },
                    play:function(){
                        var that = this;
                        this.C.SETTIME = setInterval(function(){
                            that.animation();
                        },this.D.interTime)
                        return this;
                    },
                    stopAnimate:function(){
                        clearInterval( this.C.SETTIME )
                        return this;
                    },
                    init:function(){
                        this.supplement().play().bind();
                        return this;
                    }
                };
                options.element = this;
                new _moduleCarouselTop().params( options ).init();
            })
        },
        moduleCarouselCheckout:function( params ){
            var defaults = {
                index: 0,
                speed: 200
            };
            var options = $.extend( defaults, params )
            return this.each(function(){
                var _moduleCarouselCheckout = function(){};
                _moduleCarouselCheckout.prototype = {
                    params:function( _options ){
                        this.P = _options; // prototype
                        this.E = {};
                        this.E.UL = $(_options.element);
                        this.E.L = $( this.P.Left );
                        this.E.R = $( this.P.Right );
                        this.C = {}; // Control
                        this.C.INDEX = this.P.index;
                        this.D = {}; // Data
                        this.D.LENGTH = this.P.Length;
                        this.D.SPEED = this.P.speed;
                        this.D.WIDTH = this.P.width;
                        return this
                    },
                    limit:function(){
                        $(this.E.L).removeClass('unable');
                        $(this.E.R).removeClass('unable');
                        if( this.C.INDEX >= 0 ){ $(this.E.L).addClass('unable') }
                        if( ( this.C.INDEX - 1 ) < this.D.MAX ){ $(this.E.R).addClass('unable') }
                        return this;
                    },
                    supplement:function(){
                        this.D.PAGE = Math.ceil( this.P.Length / this.P.singlePro );
                        this.D.MIN = 0;
                        this.D.MAX = ( -1 * this.D.PAGE ) + 1;
                        return this
                    },
                    bind:function(){
                        var that = this;
                        this.E.L.on('click',function(){
                            if(  that.C.INDEX  >= that.D.MIN ){ return false }else{ that.animation('right') }
                        })
                        this.E.R.on('click',function(){
                            if( ( that.C.INDEX - 1 ) < that.D.MAX ){ return false }else{ that.animation('left') }
                        })
                        return this
                    },
                    animation:function( direction ){
                        var that = this;
                        switch( direction ){
                            case "left":
                                $(that.E.UL).stop().animate({'left': ( ( that.C.INDEX + -1 ) * that.D.WIDTH ) }, that.D.SPEED ,function(){ that.C.INDEX -= 1; that.limit(); })
                                break;
                            case "right":
                                $(that.E.UL).stop().animate({'left': ( ( that.C.INDEX + 1 ) * that.D.WIDTH ) }, that.D.SPEED ,function(){ that.C.INDEX += 1; that.limit(); })
                                break;
                        }
                        return this
                    },
                    init:function(){
                        this.supplement().limit().bind();
                        return this
                    }
                };
                options.element = this;
                new _moduleCarouselCheckout().params( options ).init()
            })
        }
    })
});


// WEBPACK FOOTER //
// ./common/UMD/jQueryExtend.js